import { render } from "./activities-page.vue?vue&type=template&id=5eb69b92"
import script from "./activities-page.vue?vue&type=script&lang=js"
export * from "./activities-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__